import { Component } from '@angular/core';
import { environmentCommon } from '../../../../environments/environment-common';
import { BRAND } from '../../../data/brand/brand.data';
import { URLS } from '../../../data/navigation/navigation.data';

/**
 * Brand resources (owner 2026-10-12, redone from scratch): the Apps & Plugins hero band with a chip per resource,
 * then every resource as the home's box, the words at the left and the thing itself on a stage at the right.
 */
@Component( {
  selector: 'app-branding-page',
  templateUrl: './branding-page.component.html',
  styleUrls: [
    '../tool-pages/tools-page/tools-page.component.scss',
    '../plugin-pages/plugins-page/plugins-page.component.scss',
    './branding-page.component.scss',
  ]
} )
export class BrandingPageComponent {

  BRAND = BRAND;
  URLS = URLS;
  environmentCommon = environmentCommon;

  pageSections: { key: string; label: string }[] = [
    { key: 'guidelines', label: 'Guidelines' },
    { key: 'colors', label: 'Colors' },
    { key: 'logo', label: 'Logo' },
    { key: 'inline', label: 'Inline Logos' },
    { key: 'wallpapers', label: 'Wallpapers' },
    { key: 'mobile', label: 'Mobile Wallpapers' },
    { key: 'badges', label: 'Badges' },
  ];

  readonly rules = [
    'Keep the logo upright, never rotated',
    'Keep its own colors, never recolored',
    'Scale it in proportion, never stretched',
    'Leave clear space round it, at least its x-height',
    'Use it at 100px wide or more; ask us for smaller',
  ];

  // Codigrate's OWN colours, whatever theme the visitor has picked (not the live --theme-color)
  readonly colors = [
    { name: 'Brand Color', hex: '#00BAFF' },
    { name: 'Secondary Color', hex: '#00FFFF' },
    { name: 'Tertiary Color', hex: '#000000' },
  ];

  wallpapers = [
    { asset: BRAND.wallpapers[ 0 ], name: 'Blue' },
    { asset: BRAND.wallpapers[ 2 ], name: 'Light' },
    { asset: BRAND.wallpapers[ 1 ], name: 'Dark' },
    { asset: BRAND.wallpapers[ 3 ], name: 'Dynamic' },
  ].filter( w => w.asset );

  mobileWallpapers = [
    { asset: BRAND.mobileWallpapers[ 0 ], name: 'Blue' },
    { asset: BRAND.mobileWallpapers[ 2 ], name: 'Light' },
    { asset: BRAND.mobileWallpapers[ 1 ], name: 'Dark' },
  ].filter( w => w.asset );

  badges = [
    { asset: BRAND.badges[ 0 ], name: 'Badge, Light', label: 'Light' },
    { asset: BRAND.badges[ 1 ], name: 'Badge, Dark', label: 'Dark' },
  ].filter( b => b.asset );

  /** the full resolution PNG of a shown (minified webp) brand asset */
  raw( min: string ): string {
    return min.replace( 'min/', '' ).replace( '.min', '' ).replace( '.webp', '.png' );
  }

  /** A chip in the hero: scroll to its box instead of leaving the page, and put the keyboard focus there */
  jumpTo( key: string, event?: Event ): void {
    event?.preventDefault();
    const box = document.getElementById( 'sec-' + key );
    if ( !box ) { return; }
    box.scrollIntoView( { behavior: 'smooth', block: 'start' } );
    box.focus( { preventScroll: true } );
  }
}
